<template>
	<div class="mainBox" style="padding-bottom: 0.1rem;">
		<div class="topNav">
			<van-nav-bar safe-area-inset-top :placeholder="true" :fixed="true" title="再次报验" left-text="返回" left-arrow
				@click-left="goBack">
			</van-nav-bar>
		</div>
		<van-form @submit="onSubmit">
			<van-cell-group>
				<div class="formItem">
					<div class="formLabel">标的物</div>
					<div class="formValue">{{ subjectMatter }}</div>
				</div>
				<div class="formItem">
					<div class="formLabel">专业</div>
					<div class="formValue">{{ majorName }}</div>
				</div>
				<!-- <div class="formItem">
					<div class="formLabel">范畴</div>
					<div class="formValue">{{categoryName}}</div>
				</div> -->
				<div class="formItem">
					<div class="formLabel">序号</div>
					<div class="formValue">{{ nextSortCode }}</div>
				</div>
				<!-- <div class="formItem">
					<div class="formLabel">检验形式</div>
					<div class="formValue">{{checkType}}</div>
				</div>
				<div class="formItem">
					<div class="formLabel">部件</div>
					<div class="formValue">{{parts}}</div>
				</div> -->
				<div class="formItem">
					<div class="formLabel">检验内容</div>
					<div class="formValue">{{ content }}</div>
				</div>
			</van-cell-group>
			<van-cell-group style="margin-top: 13px;">
				<van-field readonly clickable :value="date" name="date" label="检验时间" placeholder="请选择检验时间"
					:rules="[{ required: true, message: '' }]" @click="showDateCalendar = true" />
				<van-calendar v-model="showDateCalendar" :min-date="minDate" :max-date="maxDate" color="#1989fa"
					@confirm="selDateCalendar" />
				<van-field v-model="userName" name="userName" label="检验人" placeholder="请输入检验人"
					:rules="[{ required: true, message: '' }]" />
				<van-field readonly clickable :value="conclusion" name="conclusion" label="检验结论" placeholder="请选择1次检验结论"
					@click="showConclusionPicker = true && codeFlg == '1'" />
				<van-popup v-model="showConclusionPicker" position="bottom">
					<van-picker show-toolbar :columns="conclusionList" value-key="displayName"
						@confirm="selConclusionPicker" @cancel="showConclusionPicker = false" />
				</van-popup>
				<van-field readonly clickable :value="conclusion2" name="conclusion2" label="2次检验结论" placeholder="请选择2次检验结论"
					@click="showConclusion2Picker = true && codeFlg == '2'" />
				<van-popup v-model="showConclusion2Picker" position="bottom">
					<van-picker show-toolbar :columns="conclusionList" value-key="displayName"
						@confirm="selConclusion2Picker" @cancel="showConclusion2Picker = false" />
				</van-popup>
				<van-field readonly clickable :value="conclusion3" name="conclusion3" label="2次以上结论"
					placeholder="请选择2次以上检验结论" @click="showConclusion3Picker = true && codeFlg == '3'" />
				<van-popup v-model="showConclusion3Picker" position="bottom">
					<van-picker show-toolbar :columns="conclusionList" value-key="displayName"
						@confirm="selConclusion3Picker" @cancel="showConclusion3Picker = false" />
				</van-popup>
				<van-field class="textareaField" v-model="sutContent" type="textarea" name="sutContent" label="检验意见"
					placeholder="请输入检验意见" :rules="[{ required: true, message: '' }]" />
				<van-field class="textareaField" v-model="remark" type="textarea" name="remark" label="备注"
					placeholder="请输入备注" />
				<van-field readonly clickable :value="closeTime" name="closeTime" label="封闭时间" placeholder="请选择封闭时间"
					@click="showCloseTimeCalendar = true" />
				<van-calendar v-model="showCloseTimeCalendar" :min-date="minDate" :max-date="maxDate" color="#1989fa"
					@confirm="selCloseTimeCalendar" />
				<van-cell-group style="margin-top: 13px;">
					<van-field class="uploaderField" name="scenePhotoList" label="整改前照片">
						<template #input>
							<van-uploader v-model="scenePhotoList" :after-read="uploadBeforePhoto"
								:before-delete="beforePhotoDelete" accept="image/*" />
						</template>
					</van-field>
				</van-cell-group>
				<van-cell-group style="margin-top: 13px;">
					<van-field class="uploaderField" name="closePhotoList" label="整改后照片">
						<template #input>
							<van-uploader v-model="closePhotoList" :after-read="uploadClosePhoto"
								:before-delete="closePhotoDelete" accept="image/*" />
						</template>
					</van-field>
				</van-cell-group>
				<!-- <van-field
					class="uploaderField"
					name="fileList" label="照片">
					<template #input>
						<van-uploader v-model="fileList" :after-read="uploadFile" 
						:before-delete="beforeDelete"
						accept="image/*" multiple
						/>
					</template>
				</van-field> -->
			</van-cell-group>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">保存</van-button>
			</div>
		</van-form>

	</div>
</template>
<script>
import { info, saveAgainTestRecord } from '../../api/safeInspection'
import { upload, getInspectionConclusion, getProblemImportant } from '../../api/commonApi'
import { getNowDate } from "../../utils/date"
import { Notify } from 'vant';
import ImageCompressor from '@/utils/ImageCompressor'
import common from '../../utils/common';

export default {
	name: 'safeInspectionRepeat',
	data() {
		return {
			id: "",
			subjectMatter: "",
			subjectMatterId: "",
			nextSortCode: '',
			majorName: "",
			majorId: "",
			categoryName: "",
			categoryId: "",
			checkType: "",
			checkTypeId: "",
			parts: "",
			date: "",
			showDateCalendar: false,
			showCloseTimeCalendar: false,
			content: "",
			// 画面中的项目：检验意见
			sutContent: "",
			// 备注
			remark: "",
			conclusion: "",
			conclusionId: "",
			conclusion2: "",
			conclusionId2: "",
			conclusion3: "",
			conclusionId3: "",
			showConclusionPicker: false,
			showConclusion2Picker: false,
			showConclusion3Picker: false,
			codeFlg: "",
			important: "",
			importantId: "",
			showImportantPicker: false,
			importantList: [
			],
			// 模拟数据
			conclusionList: [
			],
			userName: "",
			fileList: [],
			param: {},
			minDate: new Date(new Date().getFullYear() - 2, 0, 1, 0, 0, 0),
			maxDate: new Date(new Date().getFullYear() + 2, 11, 31, 23, 59, 59),
			user: {},
			workNo: '',
			applyDate: '',
			oldTestId: '',
			addPhotoList: [],
			ddScenePhotoList: [],
			scenePhotoList: [],
			addCloseFileList: [],
			closeFileList: [],
			addClosePhotoList: [],
			closePhotoList: [],
			closeTime: "",
			closeMan: "",
			businessType: "10", // 业务类型: 01:报验记录照片 10:问题照片 11:问题及意见文件 20:收文、发文、周报、月报等文件信息 93:协调记录照片 94:质量进度照片 95:周月报照片临时文件 96:完工资料 97:合同扫描件 98:加班审核 99:请假审核"
			fileKey: "0", // 业务类型=(01、10、11、96、97、98、99)时，默认值0，业务类型=20时，需要传入文件类型下拉选择列表对应的VALUE")
		}
	},
	mounted() {
		this.project = common.getProject();
		if (this.project == null || this.project == undefined || !this.project.workNo) {
			Notify({ type: 'danger', message: '获取工作控制号失败' });
		}
		this.user = common.getUser();
		this.applyMan = this.user.username
		this.userName = this.user.username

		this.id = this.$route.query.id;
		this.date = getNowDate()
		this.applyDate = getNowDate()
		this.doGetInspectionConclusion()
		this.doGetProblemImportant()
		this.getInfo(this.id)
	},
	methods: {
		getInfo(id) {
			info(id).then(response => {
				if (response.data.resultCode != 200) {
					Notify({ type: 'danger', message: response.data.resultMessage });
					return
				}
				const data = response.data.body
				this.param = data
				// 回显
				// 标的物ID
				this.subjectMatterId = data.subjectNo;
				// 标的物（不能修改）
				this.subjectMatter = data.subjectName;
				// 专业（不能修改）
				this.majorName = data.majorName;
				// 序号（不能修改）
				this.nextSortCode = data.nextSortCode;
				this.majorId = data.major;
				// 范畴（不能修改）
				this.categoryName = data.categoryName
				// 范畴。质量：1 ； 安全：2； 进度：3
				this.categoryId = data.category
				// 检验形式（不能修改）
				this.checkType = data.testTypeName;
				this.checkTypeId = data.testType;
				// 检验内容（不能修改）
				this.content = data.probContext
				// APP端部件是不允许编辑（不能修改）
				this.parts = data.partsName

				// 再次报验相同参数，隐藏的值
				this.workNo = data.workNo
				this.oldTestId = data.testId
				this.containCode(this.nextSortCode)
			})
		},
		containCode(recSortCode) {
			var sortCode = recSortCode + "";
			var numReg = /^[0-9]+$/
			var numRe = new RegExp(numReg)
			if (numRe.test(sortCode)) {
				this.codeFlg = '1';
			} else if (sortCode.lastIndexOf('A') == sortCode.length - 1) {
				this.codeFlg = '2';
			} else {
				this.codeFlg = '3';
			}
		},
		// 检验结论
		doGetInspectionConclusion() {
			getInspectionConclusion().then(response => {
				this.conclusionList = response.data.body
			})
		},
		// 重要程度
		doGetProblemImportant() {
			getProblemImportant().then(response => {
				this.importantList = response.data.body
			})
		},
		goBack() {
			this.$router.push({
				name: 'safeInspectionList'
			});
		},
		selConclusionPicker(data) {
			this.conclusion = data.displayName;
			this.conclusionId = data.displayValue;
			this.showConclusionPicker = false;
			if (this.conclusionId == '0') {
				// clear import value
				this.important = '';
				this.importantId = '';
			}
		},
		selConclusion2Picker(data) {
			this.conclusion2 = data.displayName;
			this.conclusionId2 = data.displayValue;
			this.showConclusion2Picker = false;
		},
		selConclusion3Picker(data) {
			this.conclusion3 = data.displayName;
			this.conclusionId3 = data.displayValue;
			this.showConclusion3Picker = false;
		},
		selDateCalendar(date) {
			this.date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			this.showDateCalendar = false;
		},
		selCloseTimeCalendar(date) {
			this.closeTime = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			this.showCloseTimeCalendar = false;
		},
		selImportantPicker(data) {
			this.important = data.displayName;
			this.importantId = data.displayValue;
			this.showImportantPicker = false;
		},
		async uploadFile(file) {
			// 此时可以自行将文件上传至服务器
			const files = file.file;
			let newFile = await ImageCompressor(files); //图片压缩
			const formData = new FormData();
			formData.append('file', newFile);
			const url = this.project.workNo + "/" + this.businessType + "/" + this.fileKey;
			upload(url, formData).then(response => {
				if (response.data.resultCode === 200) {
					const dataBody = response.data.body
					this.addCloseFileList.push(
						{
							recFileType: '2',
							fileName: this.extractFileName(dataBody.fileName),
							filePath: dataBody.fileSavePath,
							photoPathUri: dataBody.fileUri
						}
					)
				}
			})
		},
		extractFileName(fileName) {
			let index = fileName.lastIndexOf(".");
			return fileName.substr(0, index)
		},
		async uploadClosePhoto(file) {
			// 此时可以自行将文件上传至服务器
			const files = file.file;
			let newFile = await ImageCompressor(files); //图片压缩
			const formData = new FormData();

			formData.append('file', newFile);
			const url = this.project.workNo + "/" + this.businessType + "/" + this.fileKey;
			upload(url, formData).then(response => {
				if (response.data.resultCode === 200) {
					const dataBody = response.data.body
					this.addClosePhotoList.push(
						{
							recFileType: '1',
							fileName: dataBody.fileName,
							filePath: dataBody.fileSavePath,
							photoPathUri: dataBody.fileUri
						}
					)
				}
			})
		},
		async uploadBeforePhoto(file) {
			console.log(file)
			// 此时可以自行将文件上传至服务器
			const files = file.file;
			console.log(files)
			let newFile = await ImageCompressor(files); //图片压缩
			const formData = new FormData();

			formData.append('file', newFile);
			const url = this.project.workNo + "/" + this.businessType + "/" + this.fileKey;
			upload(url, formData).then(response => {
				if (response.data.resultCode === 200) {
					const dataBody = response.data.body
					this.addScenePhotoList.push(
						{
							recFileType: '0',
							fileName: dataBody.fileName,
							filePath: dataBody.fileSavePath,
							photoPathUri: dataBody.fileUri
						}
					)
					console.log(this.addScenePhotoList)
				}
			})
		},
		beforeDelete(file, detail) {
			this.fileList.splice(detail.index, 1)
			// 删除照片
			this.addPhotoList.splice(detail.index, 1)
		},
		beforePhotoDelete(file, detail) {
			this.scenePhotoList.splice(detail.index, 1)
			// 删除照片
			this.addScenePhotoList.splice(detail.index, 1)
		},
		closePhotoDelete(file, detail) {
			this.closePhotoList.splice(detail.index, 1)
			// 删除照片
			this.addClosePhotoList.splice(detail.index, 1)
		},
		closeFileDelete(file, detail) {
			this.closeFileList.splice(detail.index, 1)
			// 删除照片
			this.addCloseFileList.splice(detail.index, 1)
		},
		onSubmit(data) {
			if (!common.hasPermision("information:apply:2")) {
				Notify({ type: 'danger', message: "无操作权限" });
				return;
			}
			const param = {
				t: new Date().getTime(),
				testId: '',
				workNo: this.workNo,
				recSortCode: this.nextSortCode,
				name: "0",// 后端没有对应字段
				subjectNo: this.subjectMatterId,
				desc: "",// 后端没有对应字段
				major: this.majorId,
				applyDate: this.applyDate,
				// 图片list
				list: this.addPhotoList,
				applyMan: this.applyMan,
				testConclusion: this.conclusionId,
				testConclusion2: this.conclusionId2,
				testConclusion3: this.conclusionId3,
				testDate: this.date,
				testMan: this.userName,
				testTimes: 1,//PC端传值=1
				// 参考文件/标准
				testReferences: "",
				category: this.categoryId,
				partsName: this.parts,
				// 重要程度
				iptFlg: this.importantId,
				oldTestId: this.oldTestId,
				testType: this.checkTypeId,
				// 检验内容
				probContext: this.content,
				// 整改意见（PC端实际上传的画面中项目【检验意见】的值）
				sutContent: this.sutContent,
				// 备注
				remark: this.remark,
				scenePhotoList: this.addScenePhotoList,
				closeFileList: this.addCloseFileList,
				closePhotoList: this.addClosePhotoList,
				closeTime: this.closeTime
			}
			saveAgainTestRecord(param).then(response => {
				if (response.data.resultCode === 200) {
					Notify({ type: 'success', message: '操作成功' });
					this.goBack()
				} else {
					Notify({ type: 'danger', message: response.data.resultMessage });
				}
			})
		},
	}
}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>
<style lang="scss" scoped>
.formItem {
	position: relative;
	display: -webkit-box;
	display: -webkit-flex;
	display: flex;
	box-sizing: border-box;
	width: 100%;
	padding: 10px 16px;
	overflow: hidden;
	color: #323233;
	font-size: 14px;
	line-height: 24px;
	background-color: #fff;

	.formLabel {
		-webkit-box-flex: 0;
		-webkit-flex: none;
		flex: none;
		box-sizing: border-box;
		width: 6.2em;
		margin-right: 12px;
		color: #646566;
		text-align: left;
		word-wrap: break-word;
	}

	.formValue {
		position: relative;
		overflow: hidden;
		color: #1989fa;
		text-align: left;
		vertical-align: middle;
		word-wrap: break-word;
		-webkit-box-flex: 1;
		-webkit-flex: 1;
		flex: 1;
	}

	&::after {
		position: absolute;
		box-sizing: border-box;
		content: ' ';
		pointer-events: none;
		right: 16px;
		bottom: 0;
		left: 16px;
		border-bottom: 1px solid #ebedf0;
		-webkit-transform: scaleY(.5);
		transform: scaleY(.5);
	}
}
</style>